<div class="grid mt-1">
  <!-- Metric Cards -->
  <div class="col-12 md:col-6">
    <div class="surface-card p-3 border-round shadow-1">
      <div class="flex align-items-center gap-2">
        <div class="text-2xl font-bold">{{customerName}}</div>
      </div>
    </div>
  </div>

  <div class="col-12 md:col-3">
    <div class="surface-card p-3 border-round shadow-1">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-box text-primary text-xl"></i>
          <span class="text-700">Total Loads</span>
        </div>
        <div class="text-2xl font-bold">{{totalLoads}}</div>
      </div>
    </div>
  </div>

  <div class="col-12 md:col-3">
    <div class="surface-card p-3 border-round shadow-1">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-truck text-primary text-xl"></i>
          <span class="text-700">Active Loads</span>
        </div>
        <div class="text-2xl font-bold">{{activeLoads}}</div>
      </div>
    </div>
  </div>
</div>

<!-- After the metric cards div -->
<div class="surface-card p-3 mt-2 border-round shadow-1">
  <div class="flex justify-content-between align-items-center mb-2">
    <div class="text-900 font-medium text-xl">Performance Metrics</div>
    <p-dropdown [options]="chartRangeOptions" [(ngModel)]="selectedChartRange" (onChange)="onChartRangeChange()"
      styleClass="p-button-outlined"></p-dropdown>
  </div>
  <p-chart type="line" [data]="chartData" [options]="chartOptions" height="250px"></p-chart>
</div>

<!-- After the chart div -->
<div class="surface-card p-3 mt-3 border-round shadow-1">
  <div class="flex justify-content-between align-items-center mb-2">
    <div class="text-900 font-medium text-xl">Customer Loads</div>
    <div class="flex gap-2">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText [(ngModel)]="searchTerm" placeholder="Search loads...">
      </span>
      <p-dropdown [options]="statusFilters" [(ngModel)]="selectedStatus" placeholder="Status"
        [showClear]="true"></p-dropdown>
    </div>
  </div>
  <p-table [value]="loads" [rows]="10" [paginator]="true" [rowHover]="true" [scrollable]="true" scrollHeight='20vh'
    styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width:100px">Pickup Number</th>
        <th style="min-width:120px">Pickup Date</th>
        <th style="min-width:120px">Delivery Date</th>
        <th style="min-width:150px">From</th>
        <th style="min-width:150px">To</th>
        <th style="min-width:120px">Status</th>
        <th style="min-width:150px">Driver</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-load>
      <tr>
        <td>{{load.pickup_number}}</td>
        <td>{{load.pickup_date | date}}</td>
        <td>{{load.delivery_date | date}}</td>
        <td>{{getCustomerName(load.supplier_id)}}</td>
        <td>{{getCustomerName(load.receiver_id)}}</td>
        <td>
          <p-tag [value]="load.load_status" [severity]="getStatusSeverity(load.load_status)"></p-tag>
        </td>
        <td>{{load.pickup_driver_id}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center p-4">
          <div class="text-700">No loads found</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>